import React from 'react'

type StatusType = 'Active' | 'Inactive' | 'Pending' | 'Suspended' | 'Deleted' | string

interface StatusBadgeProps {
  status: StatusType
  size?: 'sm' | 'md'
}

const statusColors: Record<string, string> = {
  Active: 'bg-green-100 text-green-800',
  Inactive: 'bg-gray-100 text-gray-800',
  Pending: 'bg-yellow-100 text-yellow-800',
  Suspended: 'bg-red-100 text-red-800',
  Deleted: 'bg-red-100 text-red-800'
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'sm' }) => {
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-2.5 py-1.5 text-sm'

  return (
    <span
      className={`${sizeClasses} font-medium rounded-full ${
        statusColors[status] || 'bg-gray-100 text-gray-800'
      }`}
    >
      {status}
    </span>
  )
}

export default StatusBadge
